import Vue from 'vue'
import request from '@/helpers/request'
import { GET_FEEDBACK_STATUSES } from '@/store/action_types'
import { SET_FEEDBACK_STATUSES } from '@/store/mutation_types'

export default {
  GET_FEEDBACK_STATUSES({ commit, state }) {
    const feedbackStatuses = Object.values(Vue.config.feedback_statuses)
    commit('SET_FEEDBACK_STATUSES', feedbackStatuses)
  },
  [GET_FEEDBACK_STATUSES]({ commit, state }, { callback }) {
    request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.feedbackStatuses.all}`, {}, true).then(
      response => {
        const data = response.data
        if (data.result == 'success') {
          const feedbackStatuses = data.data.items
          commit(SET_FEEDBACK_STATUSES, feedbackStatuses)
          callback ? callback(feedbackStatuses) : null
        }
      },
    )
  },
}
